import { Badge } from '@mantine/core'

export type Priority = 'low' | 'medium' | 'high' | 'critical'

const PRIORITY_CONFIG: Record<Priority, { color: string; label: string }> = {
  low:      { color: 'gray',   label: 'Baixa' },
  medium:   { color: 'blue',   label: 'Média' },
  high:     { color: 'orange', label: 'Alta' },
  critical: { color: 'red',    label: 'Crítica' },
}

interface PriorityBadgeProps {
  priority: Priority | string
  size?: 'xs' | 'sm' | 'md'
}

export function PriorityBadge({ priority, size = 'sm' }: PriorityBadgeProps) {
  const config = PRIORITY_CONFIG[priority as Priority] ?? { color: 'gray', label: priority }
  const variant = priority === 'critical' ? 'filled' : 'light'
  return (
    <Badge color={config.color} variant={variant} size={size} aria-label={`Prioridade: ${config.label}`}>
      {config.label}
    </Badge>
  )
}
